import React, { useMemo, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../../../../../../../../components/Common/UI/Dialog';
import DataTable from '../../../../../../../../../components/Common/UI/DataTable';
import Separator from '../../../../../../../../../components/Common/UI/Separator';
import { Button } from '../../../../../../../../../components/Common/UI/Button';
import Icons from '../../../../../../../../../components/Common/Icons/Icons';
import { ScanTimeRes, scanTimeCol } from './columns';
import { StatusBadge } from '../../../../../../../../../components/Common/StatusBadge';
import { JobSubTableAccount } from '../../../subTableConfig';

const data2: ScanTimeRes[] = [
  {
    scanTime: '2024-01-08T21:15:00Z',
    uspsCodeDesc: '[918] Delivered',
    facility: 'COPPELL TX 75099',
  },
  {
    scanTime: '2024-02-09T19:15:00Z',
    uspsCodeDesc: '[918] Delivered',
    facility: 'MAXELL TX 44001',
  },
  {
    scanTime: '2024-01-08T21:15:00Z',
    uspsCodeDesc: '[918] Delivered',
    facility: 'COPEN TX 32079',
  },
];

interface ScanDetailsDialog {
  variant: 'truck' | 'camera'; // | 'none'
  status?: string | 'NA' | 'Delivered';
  userData?: JobSubTableAccount;
}

function ScanDetailsDialog({ variant, status, userData }: ScanDetailsDialog) {
  const [modalOpen, setModalOpen] = useState(false);
  const [cameraValue, setCameraValue] = useState<{ label: string; value: JSX.Element } | null>(null);

  const dataUser: { label: string; value: React.ReactNode }[] = useMemo(() => {
    const newItems: { label: string; value: React.ReactNode }[] = [
      {
        label: 'Account Number',
        value: userData?.accountNumber || '1021258',
      },
      {
        label: 'Customer Name',
        value: userData?.accountName || 'LUKE SCHLOTTERBECK',
      },
      {
        label: 'Intelligent Mail Identification',
        value: userData?.accountNumber || '000375473457120672371',
      },
      {
        label: 'Destination',
        value: userData?.address || 'LUKE SCHLOTTERBECK,, 6396 BADGER LAKE AVENUE SAN DIEGO, CA 92119',
      },
    ];

    const statusItem = {
      label: 'Status',
      value: <StatusBadge status="delivered" />,
    };
    const cameraItem = {
      label: 'Camera Image',
      value: <img src="/infoTrac/images/pdf-details-scan-2.png" alt="scan-details" className="w-max-64 h-max-96" />,
    };

    if (status === 'Delivered') {
      newItems.push(statusItem);
    } else {
      newItems.push({ label: 'Status', value: status || 'NA' });
    }

    if (variant === 'camera') {
      newItems.push(cameraItem);
    }
    if (variant === 'truck') {
      setCameraValue(cameraItem);
    }

    return newItems;
  }, [variant, status, userData]);

  return (
    <Dialog open={modalOpen} onOpenChange={isOpen => setModalOpen(isOpen)}>
      <DialogTrigger variant="ghost" className="">
        {variant === 'truck' ? <Icons.Truck /> : <Icons.Camera />}
      </DialogTrigger>

      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-4 mb-[10px]">
            <Icons.USPSScan width={32} height={32} />

            <div>
              <p className="text-xl leading-none">USPS Scan Details</p>
              <p className="text-muted-foreground font-normal text-base">Some text description</p>
            </div>
          </DialogTitle>
        </DialogHeader>

        <div className="grid grid-cols-[244px_1fr] rounded-lg child:border child:px-4 child:py-2">
          {dataUser.map(({ label, value }) => (
            <>
              <div>{label}</div>
              <div>{value}</div>
            </>
          ))}
        </div>

        {variant === 'truck' && status === 'Delivered' ? (
          <>
            <DataTable columns={scanTimeCol} data={data2} variant="bordered" />
            <div className="grid grid-cols-[244px_1fr] rounded-lg child:border child:px-4 child:py-2">
              {cameraValue ? (
                <>
                  <div>{cameraValue.label}</div>
                  <div>{cameraValue.value}</div>
                </>
              ) : null}
            </div>
          </>
        ) : null}

        <Separator className="!mt-4" />

        <div className="flex justify-end gap-4">
          <Button
            variant="default"
            onClick={() => {
              setModalOpen(false);
            }}
          >
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

ScanDetailsDialog.defaultProps = {
  status: undefined,
  userData: undefined,
};

export default ScanDetailsDialog;
